export const INPUT_FORMAT = {
  drivers_license: "a99-99-999999",
  gsis: "999-9999999-9",
  sss: "99-99999999-9",
  philhealth: "99-999999999-9",
  pagibig: "9999-9999-9999",
  tin: "999-999-999-9999",
  ovr_number: "aa-9999999",
  boat_number: "9999",
  body_number: "9999",
  mfvr_number: "BOH-27-aaa-9999",
  tricycle_franchise_number: "T9999-99-9999",
  boat_franchise_number: "B9999-99-9999",
  plate_number: "aaa 9999"
};

export const MAX_FILE_SIZE = 5 * 1024 * 1024;

export const TALIBON_ADDRESS_INITIAL_VALUES = {
  regionCode: "070000000",
  provinceCode: "071200000",
  municipalityCode: "071243000"
};

export const FIVE_MINUTES = 5 * 60 * 1000;
export const TWO_MINUTES = 2 * 60 * 1000;
export const THIRTY_SECONDS = 30 * 1000;
